import * as React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import CustomModal from "../../Components/CustomModal/CustomModal";
import academics from "../../data/academics";

class Academics extends React.Component {
  createTimelineElement = (item) => {
    const { title: leftTitle, description: leftDescription } =
      item.modalContent.leftContent;
    const { title: rightTitle, description: rightDescription } =
      item.modalContent.rightContent;
    return (
      <VerticalTimelineElement
        key={item.id}
        className="vertical-timeline-element--education"
        contentStyle={{ background: "#19577d", color: "#fff" }}
        contentArrowStyle={{ borderRight: "7px solid  #19577d" }}
        date={item.duration}
        iconStyle={{ background: "#fff" }}
        icon={<img alt={item.iconClass} src={`/${item.iconClass}.svg`} />}
      >
        <h3 className="vertical-timeline-element-title">{item.degree}</h3>
        <h4 className="vertical-timeline-element-subtitle">{item.institute}</h4>
        <p>{item.description}</p>
        <CustomModal
          buttonLabel="KNOW MORE"
          modalTitle={`${item.degree}: ${item.institute}`}
          leftTitle={leftTitle}
          leftDescription={leftDescription}
          rightTitle={rightTitle}
          rightDescription={rightDescription}
        />
      </VerticalTimelineElement>
    );
  };
  render() {
    return (
      <div className="academics" id="academics">
        <div className="academics-container">
          <div className="academics-title">Academics</div>
          <VerticalTimeline animate={false}>
            {academics.map(this.createTimelineElement)}
          </VerticalTimeline>
        </div>
      </div>
    );
  }
}

export default Academics;
